import MuiGrid from '@mui/material/Grid';

import CenteredContent from './CenteredContent';
import Content from './Content';
import { GridComponent } from './type';

const Grid: GridComponent = ({ children, wrap = 'wrap', ...props }) => (
  <MuiGrid
    alignItems='stretch'
    container
    direction={{ md: 'row', xs: 'column' }}
    wrap={wrap}
    {...props}
  >
    {children}
  </MuiGrid>
);

Grid.Item = Content;
Grid.Centered = CenteredContent;

export default Grid;
